var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnOutlineExport = function SvgIcnOutlineExport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4714 1.52876C14.7318 1.78911 14.7318 2.21122 14.4714 2.47157L9.13807 7.8049C8.87772 8.06525 8.45561 8.06525 8.19526 7.8049C7.93491 7.54455 7.93491 7.12244 8.19526 6.86209L13.5286 1.52876C13.7889 1.26841 14.2111 1.26841 14.4714 1.52876Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 2.00016C10.6667 1.63197 10.9652 1.3335 11.3334 1.3335H14.0001C14.3683 1.3335 14.6667 1.63197 14.6667 2.00016V5.3335C14.6667 5.70169 14.3683 6.00016 14.0001 6.00016C13.6319 6.00016 13.3334 5.70169 13.3334 5.3335V2.66683H11.3334C10.9652 2.66683 10.6667 2.36835 10.6667 2.00016Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50351 2.50376C3.36471 1.64256 4.63417 1.3335 6.19992 1.3335H7.39992C7.76811 1.3335 8.06659 1.63197 8.06659 2.00016C8.06659 2.36835 7.76811 2.66683 7.39992 2.66683H6.19992C4.76567 2.66683 3.93513 2.95776 3.44632 3.44657C2.95752 3.93537 2.66659 4.76592 2.66659 6.20016V9.80016C2.66659 11.2344 2.95752 12.065 3.44632 12.5538C3.93513 13.0426 4.76567 13.3335 6.19992 13.3335H9.79992C11.2342 13.3335 12.0647 13.0426 12.5535 12.5538C13.0423 12.065 13.3333 11.2344 13.3333 9.80016V8.60016C13.3333 8.23197 13.6317 7.9335 13.9999 7.9335C14.3681 7.9335 14.6666 8.23197 14.6666 8.60016V9.80016C14.6666 11.3659 14.3575 12.6354 13.4963 13.4966C12.6351 14.3578 11.3657 14.6668 9.79992 14.6668H6.19992C4.63417 14.6668 3.36471 14.3578 2.50351 13.4966C1.64232 12.6354 1.33325 11.3659 1.33325 9.80016V6.20016C1.33325 4.63441 1.64232 3.36495 2.50351 2.50376Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnOutlineExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_outline_export.07998db1.svg";
export { ForwardRef as ReactComponent };